import { render, staticRenderFns } from "./SubmitButton.vue?vue&type=template&id=65a92e9c&scoped=true&"
import script from "./SubmitButton.vue?vue&type=script&lang=js&"
export * from "./SubmitButton.vue?vue&type=script&lang=js&"
import style0 from "./SubmitButton.vue?vue&type=style&index=0&id=65a92e9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a92e9c",
  null
  
)

export default component.exports